if(process.env.NODE_ENV === 'development') {
  window.globalData.APP_ADMIN_URL = "https://admin.jtail.test/";
  window.globalData.APP_SHOP_URL = "http://shop.jtails.daydream-lab.com/";
  window.globalData.APP_ENV = "local";
}
